import React from 'react'

export default function ContactBanner() {
  return (
  <>
  <section className="bg-gray-50">
        {/* Heading */}
        <div className="relative py-20 bg-gradient-to-r from-trogoBlue to-trogoOrange py-24 text-white overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>

        <div className="relative max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-h1 md:text-5xl font-extrabold">
            Get in Touch with TROGO
          </h1>
          <p className="mt-4 text-body text-white/90 max-w-3xl mx-auto">
             We’re here to help you with any queries related to rides, goods transport, 
            heavy vehicles, partnerships or support.
          </p>
        </div>
      </div>
{/* Main Container */}
        <div className="max-w-7xl mx-auto px-6 py-16 ">
        <div className="mt-12 grid gap-10 md:grid-cols-2">
  
  {/* Contact Info */}
  <div className="relative overflow-hidden rounded-2xl shadow-xl border bg-gradient-to-br from-blue-50 via-white to-orange-50">
 
  {/* Background Glow */}
  <div className="absolute -top-8 -left-8 w-40 h-40 bg-blue-200 opacity-40 blur-3xl rounded-full"></div>
  <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-orange-200 opacity-40 blur-3xl rounded-full"></div>

  <div className="relative z-10 p-8">

    <h2 className="text-xl font-semibold text-trogoBlue">
      Contact Information
    </h2>

    <p className="text-gray-600 mt-2">
      We’re always happy to assist you. Reach out anytime!
    </p>

    <div className="mt-6 space-y-6 text-gray-700">

      <div className="flex items-start gap-4">
        <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-blue-100 text-blue-600 text-2xl">
          📍
        </div>
        <p>
          <span className="font-semibold">Address</span><br/>
       Darhane Tal Baglan Nashik,<br/>
          Munjwad, Satana, Nashik – 423301, Maharashtra
        </p>
      </div>

      <div className="flex items-start gap-4">
        <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-100 text-orange-600 text-2xl">
          📧
        </div>
        <p>
          <span className="font-semibold">Email</span><br/>
          info@togoodsdraft.com
        </p>
      </div>

      <div className="flex items-start gap-4">
        <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-green-100 text-green-600 text-2xl">
          📞
        </div>
        <p>
          <span className="font-semibold">Phone</span><br/>
          +91 9552396672
        </p>
      </div>

      <div className="flex items-start gap-4">
        <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-purple-100 text-purple-600 text-2xl">
          🕒
        </div>
        <p>
          <span className="font-semibold">Working Hours</span><br/>
          Mon – Sat | 9:00 AM – 7:00 PM
        </p>
      </div>

    </div>

    {/* Trust Note */}
    <div className="mt-6 bg-white/70 backdrop-blur-md border rounded-xl p-4 text-small text-gray-600">
      🔐 <span className="font-semibold">We respect your privacy.</span> Your data is always protected.
    </div>

  </div>
</div>
        {/* Form */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border">
            <h2 className="text-xl font-semibold text-trogoOrange">
              Send Us a Message
            </h2>

            <form  className="mt-6 space-y-5" action="https://formspree.io/f/mdaoporl" method="POST">
              <input className="w-full p-3 border rounded-lg" type="text" name="name" placeholder="Full Name" required />
              <input className="w-full p-3 border rounded-lg" type="email" name="email" placeholder="Email Address" required />
              <input className="w-full p-3 border rounded-lg" type="tel" name="phone" placeholder="Phone Number"/>
              <textarea className="w-full p-3 border rounded-lg" rows="4" name="message" placeholder="Your Message" required ></textarea>
              <button className="w-full bg-trogoBlue text-white py-3 rounded-lg font-semibold hover:bg-trogoOrange transition">Send Message </button>
            </form>

          </div>
        </div>

        <p className="text-center text-gray-500 mt-10 text-small">
          Your privacy is important to us. We never share your information.
        </p>
      </div>
    </section>

  </>
  );
}
